import { Platform } from "../constants";

import { ConstructDestinationUrl, URLVerification } from "./components/utms";
import { type PlatformDetails } from "./platform-details";
import { UtmSpendAdditionalDetails } from "./utm-spend-details";

const PLATFORM = Platform.AD_ROLL;

export const AdRollDetails: PlatformDetails = {
  northbeamDocUrl: "",
  officialDocUrl:
    "https://help.adroll.com/hc/en-us/articles/115002424872-Add-UTMs-to-your-AdRoll-Campaigns",
  additionalDetails: UtmSpendAdditionalDetails(PLATFORM),
};

export const AdRollSetup = () => (
  <>
    <ConstructDestinationUrl platform={PLATFORM} />
    <URLVerification platform={PLATFORM} />
  </>
);
